import React from "react";
import { Button } from "@mantine/core";
import { HttpClientError } from "../../../providers/HttpClient";
import ProgressIndicator from "../../../themes/components/ProgressIndicator";
import useAudienceCount from "../../../common/hooks/useAudienceCount";

type PublishAnnouncementButtonProps = {
  tagIds: number[];
  segmentIds?: number[];
  targetingType: "tags" | "segments";
  loading?: boolean;
  submitButtonDisabled: boolean;
  onClick?: () => void;
};

const PublishAnnouncementButton: React.FC<PublishAnnouncementButtonProps> = ({
  tagIds,
  segmentIds = [],
  targetingType,
  loading,
  submitButtonDisabled,
  onClick,
}) => {
  const { audienceCount, isLoadingCount, isError, error } = useAudienceCount(
    targetingType,
    tagIds,
    segmentIds
  );

  if (loading || isLoadingCount) {
    return <ProgressIndicator />;
  }

  if (isError) {
    return <div>{HttpClientError(error)}</div>;
  }

  return (
    <Button
      id="publishAnnouncementButton"
      name="publishAnnouncementButton"
      fullWidth
      radius="md"
      type="button"
      loaderPosition="right"
      color="jem-theme"
      disabled={!audienceCount || audienceCount === 0 || submitButtonDisabled}
      onClick={onClick}
    >
      Send to {audienceCount} Employees
    </Button>
  );
};

export default PublishAnnouncementButton;
